import { FILTERS_ACTIONS, PROJECT_AWARDED_BY } from "../constant";
import request from "../services/requestService";
import {
  transformProjectListPayload,
  RemoveEmptyFieldsHelper,
  setLocalstorage,
  getLocalstorage
} from "../helper";

// services
import { getProjectList } from "../services/apiServices";

// default prams constants
const defaultProjectListFilters = {
  offset: 0,
  limit: 10,
  sortBy: "CREATED_DATE",
  sortOrder: "DESC",
  groupCategory: PROJECT_AWARDED_BY.CENTRAL
};

const sortFilters = {
  sortBy: "CREATED_DATE",
  sortOrder: "DESC"
};

const defaultProjectListFiltersFirstHit = {
  offset: 0,
  limit: 10,
  groupCategory: PROJECT_AWARDED_BY.CENTRAL
};

/**
 *
 * @param {*} params => payload for project list
 * @param {*} callWithSortFilters => call with sort filters
 */
export function GET_PROJECT_LIST_ACTION(params, callWithSortFilters = false) {
  return async dispatch => {
    /*let filters = callWithSortFilters
      ? RemoveEmptyFieldsHelper({
          ...defaultProjectListFilters,
          ...params
        })
      : RemoveEmptyFieldsHelper({
          ...defaultProjectListFiltersFirstHit,
          ...params
        });*/

    let filters = RemoveEmptyFieldsHelper({
      ...defaultProjectListFiltersFirstHit,
      ...params
      // search: params.search ? params.search.trim() : "",
    });

    /*if (params.search) {
      filters = {
        ...filters,
        projectName: `\\b${params.search.replace(/\s+/g, '\\s+')}\\b`,
      };
    }*/

    let filterArr = [
      "sponsoringMinistry",
      "sponsoringDepartment",
      "sponsoringState",
      "districtStateDept",
      "projectStage",
      "projectCost",
      "stateProjectCost",
      "recipientMinistry",
      "recipientDistDept",
      "projectTags",
      "projectSector",
      "projectImplementationMode",
      "costOverRun",
      "delayedProject",
      "projectProponent",
      "bucket",
      "milestone",
      "bucketStatus",
      "milestoneStatus",
      "projectLocation",
      "projectZones",
      "districtProjectLocation"
    ];

    let test =
      Object.keys(filters) &&
      Object.keys(filters).length &&
      Object.keys(filters).some(function(e) {
        if (filterArr.includes(e)) {
          if (Array.isArray(filters[e])) {
            return filters[e].length;
          } else {
            return true;
          }
        }
      });

    let isSortClicked = getLocalstorage("isSortClicked");

    if (test || callWithSortFilters || isSortClicked) {
      filters = { ...sortFilters, ...filters };
    } else {
      delete filters["sortBy"];
      delete filters["sortOrder"];
    }

    dispatch({ type: FILTERS_ACTIONS._PROJECT_LIST_._START, payload: filters });
    const response = await request(
      getProjectList(transformProjectListPayload(filters))
    );
    const { data, status } = response.data || {};
    if (status) {
      setLocalstorage("draftedProject", data.draftStatus.drafted || null);
      dispatch({
        type: FILTERS_ACTIONS._PROJECT_LIST_._SUCCESS,
        payload: data
      });
    } else
      dispatch({ type: FILTERS_ACTIONS._PROJECT_LIST_._FAILURE, payload: [] });
  };
}

export function CLEAR_ISSUE_OLD_FILTERS_ACTION(
  projectAwardedBy = PROJECT_AWARDED_BY.CENTRAL
) {
  return function(dispatch) {
    dispatch({
      type: FILTERS_ACTIONS._PROJECT_LIST_._CLEAR,
      payload: {
        ...defaultProjectListFilters,
        ...{ groupCategory: projectAwardedBy }
      }
    });
    // call api
    dispatch(GET_PROJECT_LIST_ACTION({ groupCategory: projectAwardedBy }));
  };
}
